import React, { useContext } from 'react';
import { ThemeOptions, ThemeContext, } from '@wix/da-react-context/pkg/ThemeContext';
var ToolbarWrapper = function (_a) {
    var children = _a.children;
    var theme = useContext(ThemeContext);
    var themeClassName = "da-editor-theme-".concat(theme === ThemeOptions.DARK ? 'dark' : 'bright');
    return (React.createElement("div", { className: themeClassName, "data-daeditor-retrieved-toolbar": true }, children));
};
ToolbarWrapper.displayName = 'ToolbarWrapper';
export default ToolbarWrapper;
//# sourceMappingURL=ToolbarWrapper.js.map